import SigninScreen from "@/screens/SigninScreen/SigninScreen";
import { AUTH_STATES } from "./authReducer";
import { useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import SessionRestoring from "@/components/SessionRestoring";
import DemoSignupScreen from "@/screens/DemoSignupScreen/DemoSignupScreen";

/**
 * AuthGate
 *
 * Responsibilities:
 *  - Block UI while auth is resolving (Suspense)
 *  - Route unathenticated users to Signin
 *  - Allow authenticated users through
 *  - Handle  special routes (demo)
 */
export default function AuthGate({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  const isDemoSignupRoute =
    location.pathname === "/demo" || location.pathname === "/demosignup";

  if (
    status === AUTH_STATES.IDLE ||
    status === AUTH_STATES.RESTORING ||
    status === AUTH_STATES.LOGGING_IN
  ) {
    return <SessionRestoring />;
  }

  if (status === AUTH_STATES.UNAUTHENTICATED || status === AUTH_STATES.ERROR) {
    // Allow demo signup screen when unauthenticated
    if (isDemoSignupRoute) {
      return <DemoSignupScreen />;
    }
    return <SigninScreen />;
  }

  if (status === AUTH_STATES.AUTHENTICATED) {
    // Redirect authenticated users away from demo signup
    if (isDemoSignupRoute) {
      return children; // This will trigger redirect in DemoSignupScreen component
    }
    return children;
  }
  return <SigninScreen />;
}
